module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 942
// module chunks = 48 49 50